function sorguDizgesi(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.kaynak)
        p.set('kaynak', s.kaynak);
    if (s.hedef)
        p.set('hedef', s.hedef);
    if (s.baslangicTen)
        p.set('baslangicTen', s.baslangicTen);
    if (s.baslangicAKadar)
        p.set('baslangicAKadar', s.baslangicAKadar);
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function dovizKurlariniListele(istemci, sorgu = {}) {
    return istemci.istek(`/doviz-kurlari${sorguDizgesi(sorgu)}`);
}
export async function dovizKuruEkle(istemci, giris) {
    return istemci.istek('/doviz-kurlari', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
//# sourceMappingURL=doviz.js.map